// extracted by mini-css-extract-plugin
export default {"heading":"mt-z","corrected":"nt-z","redirectVerbiageContainer":"ot-z","redirectVerbiageText":"pt-z"};